import React from "react";
import "./ResourceSubpage.css";
import resourceImg1 from "../../Images/resourceImg1.webp";
import resourceImg3 from "../../Images/resourceImg3.jpg";

const ResourceGuid = () => {
  return (
    <div className="resourceGuide">
      <section className="MythsguidSection">
        <div className="MythsguidText">
          <h2>Career Guides</h2>
          <p>
            Help students navigate their journey with clear, actionable guides
            tailored to different stages and interests.
          </p>
        </div>
        <div className="gudiSubHeading">
          <div className="gudiSubHeadingText">
            <h2>Break Free from Career Confusion</h2>
            <p>
              Choosing a career is one of the most personal and impactful
              decisions you'll ever make—and it's rarely a straight line. Our
              Career Guides are built to support students, job seekers, and
              professionals at every stage, whether you're exploring options,
              switching paths, or restarting after a break. We break down
              industry trends, bust outdated myths, and offer practical advice
              to help you align your strengths, interests, and values with
              real-world opportunities. From understanding what employers truly
              value to navigating unconventional paths, these guides are your
              compass in a world full of choices. Because your career isn’t just
              a job—it’s your journey.
            </p>
          </div>
          <img src={resourceImg1} alt="resourceImg1" />
        </div>
        <div className="MythsguidBlock">
          <div className="MythsguidCard">
            <h3>You must know your career path by age 18</h3>
            <p>
              <b>Reality:</b> Most people change careers multiple times.
              Exploration is part of the process. Internships, side projects,
              and diverse experiences help you discover what truly fits
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Arts degrees lead nowhere</h3>
            <p>
              <b>Reality:</b> Degrees in humanities foster critical thinking,
              communication, and creativity—skills that are in high demand
              across industries like marketing, law, UX design, and more
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Networking starts after you get a job</h3>
            <p>
              <b>Reality:</b> Building connections early—through college clubs,
              LinkedIn, or mentorship programs—can open doors to internships,
              referrals, and insider insights
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Only paid internships are valuable</h3>
            <p>
              <b>Reality:</b> Unpaid internships can still offer mentorship,
              skill-building, and exposure to real-world projects. The key is
              meaningful learning, not just busywork
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Your degree locks your career path</h3>
            <p>
              <b>Reality:</b> Career pivots are normal. Engineers become product
              managers, historians become UX designers. What matters is your
              ability to learn and adapt
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Academic grades define your future</h3>
            <p>
              <b>Reality:</b> Employers value practical skills, communication,
              and experience more than marks. A strong portfolio or internship
              can outweigh a GPA
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>There’s a deadline for success</h3>
            <p>
              <b>Reality:</b> Everyone has a unique timeline. Some find their
              calling early, others later. Consistency and curiosity matter more
              than speed
            </p>
          </div>
        </div>
      </section>
      <section className="skillBased">
        <h2>Skill-Based Careers</h2>
        <div className="skillBasedText">
          <div className="skillBasedText1">
            <h3>What Are Skill-Based Careers?</h3>
            <p>
              Skill-based careers are built around practical, hands-on abilities
              that meet real industry needs. Instead of relying solely on
              degrees, these roles prioritize certifications, portfolios, and
              demonstrable expertise. From coding and digital marketing to
              graphic design and data analytics, these careers offer faster
              entry points and high growth potential.
            </p>
          </div>
          <div className="skillBasedText1">
            <h3>Why Choose a Skill-Based Path?</h3>
            <p>
              <b>Faster Entry:</b> Many skill-based careers require short-term
              training (3–12 months), not multi-year degrees.
            </p>
            <p>
              <b>High Demand:</b> Industries like tech, design, healthcare, and
              logistics are hiring based on skills, not just qualifications.
            </p>
            <p>
              <b>Flexibility:</b> Freelance, remote, and gig opportunities are
              abundant in skill-driven fields.
            </p>
            <p>
              <b>Cost-Effective:</b> Skill courses are often more affordable and
              accessible than traditional college programs.
            </p>
          </div>
        </div>
        <div className="MythsguidBlock">
          <div className="MythsguidCard">
            <h3>Digital Marketing</h3>
            <p>
              <b>Duration: </b> 3–12 months
            </p>
            <p>
              <b>Salary: </b> ₹3–6 LPA
            </p>
            <p>
              <b>Learn: </b>Google Digital Garage, Coursera, IIDE
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Graphic Design & UI/UX</h3>
            <p>
              <b>Duration: </b> 6–12 months
            </p>
            <p>
              <b>Salary: </b> ₹4–8 LPA
            </p>
            <p>
              <b>Learn: </b>Arena Animation, Udemy, MAAC
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Data Analytics</h3>
            <p>
              <b>Duration: </b> 6–12 months
            </p>
            <p>
              <b>Salary: </b> ₹6–12 LPA
            </p>
            <p>
              <b>Learn: </b>Simplilearn, Great Learning, Coursera
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Web Development</h3>
            <p>
              <b>Duration: </b> 3–9 months
            </p>
            <p>
              <b>Salary: </b> ₹4–10 LPA
            </p>
            <p>
              <b>Learn: </b>freeCodeCamp, Udemy, Coding Ninjas
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Healthcare Technician</h3>
            <p>
              <b>Duration: </b> 6–18 months
            </p>
            <p>
              <b>Salary: </b> ₹3–5 LPA
            </p>
            <p>
              <b>Learn: </b>Skill India, Medvarsity, Apollo Medskills
            </p>
          </div>
        </div>
      </section>
      <section className="MythsguidSection">
        <div className="MythsguidText">
          <h2>Emerging Careers</h2>
        </div>
        <div className="gudiSubHeading">
          <div className="gudiSubHeadingText">
            <h2>What Are Emerging Careers?</h2>
            <p>
              Emerging careers are driven by innovation, digital transformation,
              sustainability, and changing consumer behavior. These fields are
              reshaping industries and creating new opportunities that didn’t
              exist a decade ago. As technology evolves and global priorities
              shift, roles in areas like artificial intelligence, data science,
              renewable energy, and digital content creation are becoming
              increasingly vital. These careers often require new-age skills
              such as coding, design thinking, emotional intelligence, and data
              literacy—along with a mindset of adaptability and lifelong
              learning. Unlike traditional career paths, emerging fields offer
              rapid growth, global relevance, and the chance to work on
              cutting-edge challenges. With high demand and relatively low
              competition, they’re ideal for early movers who are ready to
              embrace change and build future-proof careers.
            </p>
          </div>
          <img src={resourceImg3} alt="resourceImg1" />
        </div>
        <div className="MythsguidBlock">
          <div className="MythsguidCard">
            <h3>Artificial Intelligence & ML</h3>
            <p>
              <b>Skills:</b> Python, Deep Learning, NLP, Data Modeling
            </p>
            <p>
              <b>Salary:</b> ₹8–20 LPA
            </p>
            <p>
              <b>Growth:</b> High Demand
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Data Science & Analytics</h3>
            <p>
              <b>Skills:</b> SQL, Python, Tableau, Statistics
            </p>
            <p>
              <b>Salary:</b> ₹6–15 LPA
            </p>
            <p>
              <b>Growth:</b> Cross-industry
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Cybersecurity</h3>
            <p>
              <b>Skills:</b> Ethical Hacking, Network Security, Risk
            </p>
            <p>
              <b>Salary:</b> ₹5–12 LPA
            </p>
            <p>
              <b>Growth:</b> Urgent Need
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Blockchain Development</h3>
            <p>
              <b>Skills:</b> Solidity, Ethereum, Smart Contracts
            </p>
            <p>
              <b>Salary:</b> ₹6–18 LPA
            </p>
            <p>
              <b>Growth:</b> Fintech & Beyond
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Renewable Energy & Sustainability</h3>
            <p>
              <b>Skills:</b> Energy Systems, Climate Policy, Engineering
            </p>
            <p>
              <b>Salary:</b> ₹4–10 LPA
            </p>
            <p>
              <b>Growth:</b> Green Revolution
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>UX/UI Design</h3>
            <p>
              <b>Skills:</b> Figma, Adobe XD, User Research
            </p>
            <p>
              <b>Salary:</b> ₹4–9 LPA
            </p>
            <p>
              <b>Growth:</b> Product-Centric
            </p>
          </div>
          <div className="MythsguidCard">
            <h3>Digital Content Creation</h3>
            <p>
              <b>Skills:</b> SEO, Video Editing, Social Media Strategy
            </p>
            <p>
              <b>Salary:</b> ₹3–8 LPA
            </p>
            <p>
              <b>Growth:</b> Creator Economy
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResourceGuid;
